import * as React from "react";
import ActualForm from "../global/Form";
import SectionNumber from "../global/SectionNumber";
import SmartColour from "../../utils/ColourHandler";
import SmartText from "../../utils/TextHandler";
import SmartStyles from "../../utils/StyleHandler";

/********************************
<Form />
/********************************
Version: 1
Created: 19 02 2025
Updated: 19 02 2025
Author: Richy Pears
/********************************
Displays a form

TODO: Make accessible
/********************************/

const Form = ({ blok }) => {
  if (!blok) return null; // Escape hatch
  const {
    copy,
    ctas,
    number,
    padding,
    rounded,
    subtitle,
    theme,
    title,
    thanks,
  } = blok;

  const colour = SmartColour(theme);

  return (
    <section
      className={`flex flex-col ${
        colour.classes && colour.classes
      } ${SmartStyles("padding", padding)} ${SmartStyles("rounded", rounded)}`}
    >
      <div className="brand-container flex flex-col gap-10 md:gap-12 mb-10 md:mb-12">
        <SectionNumber title={subtitle && subtitle} number={number && number} />
        <div className="flex flex-col md:flex-row justify-center items-start gap-10">
          <div className="w-full flex flex-col gap-5 md-gap-10">
            {title && <h1 className="m-0">{title}</h1>}
            {copy?.content[0]?.content && (
              <SmartText
                className="m-0 brand-remove-last-margin"
                colour={theme}
              >
                {copy}
              </SmartText>
            )}
          </div>
          <div className="w-full">
            <ActualForm thanks={thanks?.full_slug && thanks.full_slug} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Form;
